import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import OrganizationProductTypesCreate from "modules/OrganizationProductTypes/OrganizationProductTypesCreate";
import { Link } from "react-router-dom";
import { getRoute } from "utils/routing";

export default function OrganizationProductTypeCreatePage() {
  return (
    <DashboardPage>
      <MDBox mb={6}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MDTypography variant="h4" fontWeight="medium">
              Create Organization Product Type
            </MDTypography>
          </Grid>
        </Grid>
      </MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <OrganizationProductTypesCreate />
        </Grid>
      </Grid>
    </DashboardPage>
  );
}
